import { FetchProps } from 'helpers/redial'
import { getPageTypeByPathname } from 'store/pages/static/helpers'

export default {
  fetch: async ({
    store: { staticPage, localeStore },
    pathname,
    t,
  }: FetchProps) => {
    const pageType = getPageTypeByPathname(pathname, t, localeStore.locale)

    await staticPage.initPage(pageType)
  },

  defer: ({ store }: FetchProps) => {
    store.tracking.trackBreadCrumbs()
  },
}
